// extracted by mini-css-extract-plugin
export default {"root":"MultipleModalAdditionalContent_root__7Ni0M","placeHolderShimmer":"MultipleModalAdditionalContent_placeHolderShimmer__nrApR"};